import { SvgIcon } from '@mui/material';

export const TotalNewLegendIcon = () => (
  <SvgIcon viewBox='0 0 10 10' sx={{ width: '10px', height: '10px' }}>
    <path d='M0 2C0 0.89543 0.895431 0 2 0H8C9.10457 0 10 0.895431 10 2V5H0V2Z' fill='#003F83' />
    <path
      d='M10 8C10 9.10457 9.10457 10 8 10L2 10C0.89543 10 7.8281e-08 9.10457 1.74846e-07 8L4.37114e-07 5L10 5L10 8Z'
      fill='#47BCE1'
    />
  </SvgIcon>
);
